import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";

import type { CardProps, SxProps, Theme } from "@mui/material";
import type { FC } from "react";

interface IconCardIconProps {
  icon: React.JSX.Element;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

interface Props extends CardProps {
  title: string;
  icon: IconCardIconProps;
  outlined?: boolean;
}

export const IconCard: FC<Props> = ({ title, icon, children, outlined, ...props }) => (
  <Card {...(outlined === false ? {} : { variant: "outlined" })} {...props}>
    <CardContent>
      <Grid container>
        <Grid
          size={{ xs: 12 }}
          sx={{
            justifyContent: "center",
            textAlign: "center",
            align: "center",
            display: "flex",
            mb: 3,
          }}
        >
          <Avatar
            onClick={icon.onClick}
            sx={[
              { height: "100px", width: "100px" },
              ...(Array.isArray(icon.sx) ? icon.sx : [icon.sx]),
            ]}
          >
            {icon.icon}
          </Avatar>
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ mb: 3 }}>
          <Typography align="center" variant="h6">
            {title}
          </Typography>
        </Grid>
        {children}
      </Grid>
    </CardContent>
  </Card>
);
